import { backendApi } from "./backend.api";
import { IRoute } from "shared/models/models";
import { getSpaceId } from "shared/utils/space";

export interface IRouteListQuery {
  spaceId?: number;
}

export const routeApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      routes: build.query<IRoute[], IRouteListQuery | null>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: IRouteListQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/route",
            method: "GET",
            params: params,
          };
        },
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: "Route" as const, id })),
                "Route",
              ]
            : ["Route"],
      }),
      getRoute: build.query<IRoute, string>({
        query: (id) => ({ url: `/route/${id}`, method: "GET" }),
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        providesTags: (item) => [{ type: "Route", id: item?.id }],
      }),
      addRoute: build.mutation<IRoute, Partial<IRoute>>({
        query: (payload) => {
          const spaceId = getSpaceId();
          const params: Partial<IRoute> = { ...payload };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/route",
            method: "POST",
            data: params,
          };
        },
        invalidatesTags: () => ["Route"],
        transformResponse: (response: { data: IRoute }) => response.data,
      }),
      updateRoute: build.mutation<IRoute, Partial<IRoute>>({
        query: (payload) => ({
          url: `/route/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: "Route", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      updateMultiRoute: build.mutation<IRoute[], IRoute[]>({
        query: (payload) => ({
          url: "/route/update-multi",
          method: "POST",
          data: payload,
        }),
        invalidatesTags: (result = []) => [
          ...result.map(({ id }) => ({ type: "Route", id: id }) as const),
        ],
        // transformResponse: (response: { data: IVisit[] }) => response.data,
      }),
      deleteRoute: build.mutation<IRoute, number>({
        query: (id) => ({
          url: `/route/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: ["Route"],
      }),
    };
  },
});

export const {
  useRoutesQuery,
  useAddRouteMutation,
  useDeleteRouteMutation,
  useGetRouteQuery,
  useUpdateRouteMutation,
  useUpdateMultiRouteMutation,
} = routeApi;
